import { Component, Inject, OnInit, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiRoleManagerService } from '@common/core/services';
import { ERoleActions } from '@common/enums';
import { IPrintSalesDialogData, IPrintSalesData } from '@common/interfaces';
import { EArchiveType, EPrintType } from '@web/enums';
import { environment } from '@env/environment';
import { SuperPrint } from '@web/dynamic-modules/shared/print-strategies/super-print';

@Component({
  selector: 'mpa-dynamic-print-sales-dialog',
  templateUrl: './dynamic-print-sales-dialog.component.html',
  styleUrls: ['./dynamic-print-sales-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DynamicPrintSalesDialogComponent implements OnInit {
  printForm: FormGroup;
  eRoleActions = ERoleActions;
  ePrintType = EPrintType;
  constructor(
    public uiRoleManagerService: UiRoleManagerService,
    public dialogRef: MatDialogRef<DynamicPrintSalesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: IPrintSalesDialogData,
    private formBuilder: FormBuilder
  ) {}
  ngOnInit(): void {
    this.initForm();
  }
  async onPrint() {
    let component: SuperPrint = null;
    const { items, title } = this.dialogData;
    const { layout } = this.printForm.value;
    const printData: IPrintSalesData = {
      layout,
      items,
      title,
    };
    switch (layout) {
      case EPrintType.LIST:
        switch (environment.archiveType) {
          case EArchiveType.FASHION:
            component = new (
              await import('@web/dynamic-modules/fashion/print-strategies/fashion-print-sales-list')
            ).FashionPrintSalesList();
            break;
          case EArchiveType.MULTIMEDIA:
            component = new (
              await import('@web/dynamic-modules/multimedia/print-strategies/multimedia-print-sales-list')
            ).MultimediaPrintSalesList();
            break;
          case EArchiveType.CELLAR:
            component = new (
              await import('@web/dynamic-modules/cellar/print-strategies/cellar-print-sales-list')
            ).CellarPrintSalesList();
            break;
        }
        break;
    }
    component.print(printData);

    this.dialogRef.close();
  }
  private initForm() {
    this.printForm = this.formBuilder.group({
      layout: [this.dialogData.actions[0], Validators.required],
    });
  }
}
